import React, { useEffect, useState } from "react";
import { Button, Img, Input, Text, Radio, CheckboxCustom } from "components";
import { TextField } from "@mui/material";
import { MoneyAdded } from "popups/MoneyAdded";
import { useTranslation } from "react-i18next";
import * as CUSTOM from "../../../../../../utils/helper/custom";
import * as CARDVALIDATION from "../../../../../../utils/helper/payfortValidation";
import globalRequest from "utils/global/globalRequest";
import * as APIS from "../../../../../../utils/helper/Enum";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../../../../../redux/reducers/snackbar";
import ApplePayComponent from "pages/ApplePayComponent";
import { getAuth } from "../../../../../../redux/reducers/loginData";
import { changeLoader } from "../../../../../../redux/reducers/loader";

// const Tab = styled.div`
//   /* Add the selected styles when the component is selected */
//   ${({ isSelected }) => isSelected && ` `}
// `;
// const Panal = styled.div`
//   /* Add the selected styles when the component is selected */
//   ${({ isSelected }) =>
//     isSelected &&
//     `
// display: flex;`}
// `;

const Payment = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const { paymentData, setIsAddMoney, setPaymentData, getWalletHistory } = props;
  const [cardError, setCardError] = useState({});
  const [cardList, setCardList] = useState([]);
  const [cardTypeError, setCardTypeError] = useState({});
  let [cardData, setCardData] = useState({});
  const [MoneyAddedOpen, setMoneyAddedOpen] = React.useState(false);
  const [showApplePayButton, setShowApplePayButton] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [applePayEmail, setApplePayEmail] = useState("");
  const [applePayError, setApplePayError] = useState("");

  // ── NEW: toggle to show add-new-card form inline ──
  const [showAddCard, setShowAddCard] = useState(false);

  const handleTabClick = (index) => {
    setCardData({});
    setCardError({});
    setActiveTab(index);
  };

  // const handelsetMoneyAddedOpen = () => {
  //   setMoneyAddedOpen(true);
  //   document.body.classList.add("overflow-hidden");
  //   document.getElementById("header-box").classList.add("relative");
  // };

  /**
   * verify cart if valid or not for payment
   */
  const verifyCart = () => {
    const newErrors = {};
    if (!cardData?.token_name) {
      if (cardData.card_number) {
        let resValidation = CARDVALIDATION.validateCard(cardData.card_number);
        if (!resValidation?.validity) {
          newErrors.card_number = t("cardNumberError");
        }
      } else {
        newErrors.card_number = t("cardNumberErrorEmpty");
      }
      if (cardData.expiration_date) {
        if (!CARDVALIDATION.validateExpiryDate(cardData.expiration_date)) {
          newErrors.date = t("cardDateError");
        }
      } else {
        newErrors.date = t("cardDateErrorEmpty");
      }
      if (!cardData.card_holder) {
        newErrors.card_holder = t("cardHolderError");
      } else {
        let cartHolderValidation = CARDVALIDATION.validateHolderName(cardData.card_holder);
        if (!cartHolderValidation?.validity) {
          newErrors.card_holder = t("cardNumberError");
        }
      }
    }
    if (cardData.cvv) {
      if (!cardData.cvv.match(/^\d{3,4}$/)) {
        newErrors.cvv = t("cvvNumberError");
      }
    } else {
      newErrors.cvv = t("cvvNumberErrorEmpty");
    }
    if (Object.keys(newErrors).length == 0) {
      if (!cardData?.token_name) {
        let expdata = cardData?.expiration_date.split("/");
        cardData.edate = `${expdata[1]}${expdata[0]}`;
        setCardData({ ...cardData, edate: `${expdata[1]}${expdata[0]}` });
      }
      paymentProcess("card");
    }
    setCardError(newErrors);
  };

  const checkCartType = (cardNo) => {
    let res = CUSTOM.getCardType(cardNo);
    setCardTypeError(res);
  };

  /**
   * Get Card list
   */
  const getCardList = async () => {
    try {
      let response = await globalRequest(APIS.USERS.GET_SAVED_CARD_LIST, "get", {}, {}, true);
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setActiveTab(2);
        setCardList(response?.data);
      } else {
        setActiveTab(1);
        setCardList([]);
        // auto-show add card form if no saved cards
        setShowAddCard(true);
      }
    } catch (e) {
      setCardList([]);
      setShowAddCard(true);
    }
  };

  /**
   * Add money in wallet
   */
  const paymentProcess = async (type = "", applePayData, session) => {
    dispatch(changeLoader(true));
    try {
      let cDatas = {
        ...cardData,
        ...paymentData,
        card_security_code: cardData?.token_name ? cardData?.cvv : "",
        payment_method: type ? type : null,
      };
      if (type == "apple_pay") {
        cDatas.applePayData = applePayData;
        cDatas.applePayEmail = applePayEmail;
      }
      let response = await globalRequest(APIS.USERS.ADD_MONEY_IN_WALLET, "post", cDatas, {}, true);
      response = response?.data;
      if (response?.status == "SUCCESS") {
        if (response?.data?.otp_link) {
          window.location.href = response?.data?.otp_link;
        } else if (response?.data?.is_card === 1) {
          let cData = { ...cardData, ...response?.data?.cardData, isCard: 1 };
          setCardData(cData);
        } else {
          if (type == "apple_pay") {
            session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
            CUSTOM.sendWalletGaEvent(CUSTOM.setPrice(paymentData?.amount));
            CUSTOM.sendPaymentStatusGaEvent("success", "wallet", auth?.id, auth);
            getWalletHistory();
            setPaymentData({ step: 1 });
            setIsAddMoney(false);
          }
        }
      } else {
        if (type == "apple_pay") {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
          CUSTOM.sendPaymentStatusGaEvent("failed", "wallet", auth?.id, auth);
        }
        dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: response?.message, snackbarState: "error" }));
      }
    } catch (e) {
      if (type == "apple_pay") {
        session.completePayment(window.ApplePaySession.STATUS_FAILURE);
      }
      dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: e?.message, snackbarState: "error" }));
    }
    dispatch(changeLoader(false));
  };

  const checkApplePayEmail = (email) => {
    if (email) {
      if (!CUSTOM.isValidField(email, "email")) {
        setApplePayError(t("please_enter_valid_email"));
      } else {
        setApplePayError("");
      }
    } else {
      setApplePayError(t("email_name_required"));
    }
  };

  useEffect(() => {
    getCardList();
  }, []);

  useEffect(() => {
    if (cardData?.isCard == 1) {
      let form = document.getElementById("aps_payment_form");
      if (form) {
        form.submit();
      }
    }
  }, [cardData]);

  useEffect(() => {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      setShowApplePayButton(true);
    }
  }, []);

  return (
    <>
      {/* Hidden payfort form — logic unchanged */}
      <form
        method="post"
        action={`${
          process.env.REACT_APP_PAYFORT_MODE == "TEST"
            ? process.env.REACT_APP_PAYFORT_DEVLOPMENT
            : process.env.REACT_APP_PAYFORT_PRODUCTION
        }/FortAPI/paymentPage`}
        id="aps_payment_form"
        name="aps_payment_form"
        className="hidden"
      >
        <span dangerouslySetInnerHTML={{ __html: CUSTOM.paymentFormHtml(cardData) }}></span>
      </form>

      <div className="flex flex-col w-full">

        {/* ── Saved Cards section ── */}
        {!showAddCard && cardList.length > 0 && (
          <>
            <Text className="text-[15px] font-semibold text-black-900 font-['Inter'] mb-3">
              {t("savedCards") || "Saved Cards"}
            </Text>

            {/* Cards list — each card in its own separate bordered box */}
            <div className="flex flex-col w-full gap-3 mb-4">
              {cardList.map((items, index) => {
                let tabind = index + 2;
                const isSelected = activeTab === tabind;
                return (
                  <div
                    key={`card-${items?.cardToken || index}`}
                    className={`w-full border rounded-xl overflow-hidden cursor-pointer transition-colors ${
                      isSelected ? "border-[#7B1A3C]" : "border-gray-200"
                    }`}
                    onClick={() => {
                      handleTabClick(tabind);
                      setCardData({ ...cardData, token_name: items?.cardToken });
                    }}
                  >
                    {/* Card row */}
                    <div className="flex flex-row items-center justify-between px-4 py-3.5">
                      {/* Radio + card info */}
                      <div className="flex flex-row items-center gap-3">
                        <Radio
                          name="paymentMode"
                          checked={isSelected}
                          onChange={(e) => {
                            handleTabClick(tabind);
                            setCardData({ ...cardData, token_name: items?.cardToken });
                          }}
                        />
                        <Text className="text-[18px] font-normal leading-[28px] font-['Inter'] text-[var(--Blacks-900,#1A1A1A)]">
                          {t("cardEndingIn")}{" "}
                          <span className="tracking-widest">••••</span>{" "}
                          {items?.cardNumber?.slice(-4) || items?.cardNumber}
                        </Text>
                      </div>
                      {/* Card logo */}
                      <Img
                        className="h-6 object-contain"
                        src={CUSTOM.cardTypeLogo(items?.type)}
                        alt={items?.type}
                      />
                    </div>

                    {/* CVV field when this card is selected */}
                    {isSelected && (
                      <div className="px-4 pb-4 border-t border-gray-100">
                        <div className="max-w-[200px] pt-3">
                          <Input
                            required
                            label={t("cvv")}
                            type="password"
                            value={cardData?.cvv}
                            error={cardError?.cvv}
                            onChange={(e) => {
                              setCardData({
                                ...cardData,
                                token_name: items?.cardToken,
                                cvv: CUSTOM.strFormat(e.target.value, "max:4|number"),
                              });
                              setCardError({ ...cardError, cvv: "" });
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* + Add New Card button */}
            <button
              className="flex flex-row items-center justify-center gap-2 w-full py-3 border border-gray-200 rounded-full text-[14px] font-medium text-black-900 font-['Inter'] bg-white hover:bg-gray-50 transition-colors mb-5 cursor-pointer"
              onClick={() => {
                setShowAddCard(true);
                handleTabClick(1);
              }}
            >
             <span className="text-[16px] font-medium leading-[24px] text-center font-['Unbounded'] text-[var(--Blacks-900,#1A1A1A)]">
              + &nbsp;&nbsp;{t("AddNewCard")}
            </span>
              
            </button>
          </>
        )}

        {/* ── Add New Card form ── */}
        {showAddCard && (
          <>
            <div className="flex flex-row items-center justify-between mb-4">
              <Text className="text-[20px] font-medium leading-[28px] font-['Inter'] text-[var(--Blacks-900,#1A1A1A)]">
                {t("addingNewCard")}
              </Text>
              {/* Back to saved cards if there are any */}
              {cardList.length > 0 && (
                <button
                  className="text-[14px] font-medium leading-[28px] font-['Inter'] text-[var(--Blacks-900,#1A1A1A)]"
                  onClick={() => {
                    setShowAddCard(false);
                    setCardData({});
                    setCardError({});
                  }}
                >
                  {t("backToSavedCards") || "Back"}
                </button>
              )}
            </div>

            {/* Card Holder Name */}
            <div className="flex flex-col w-full mb-3">
              <Text className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[#6D737E] mb-1.5">
                {t("cardHolderName")} *
              </Text>
              <Input
                className="w-full figma-input"
                placeholder={t("enterYourCardName") || "Enter your card name"}
                value={cardData?.card_holder}
                error={cardError?.card_holder}
                onChange={(e) => {
                  setCardData({
                    ...cardData,
                    card_holder: CUSTOM.strFormat(e.target.value, "text|max:50"),
                  });
                  setCardError({ ...cardError, card_holder: "" });
                }}
              />
            </div>

            {/* Card Number */}
            <div className="flex flex-col w-full mb-3">
              <Text className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[#6D737E] mb-1.5">
                {t("cardNumber")} *
              </Text>
              <Input
                className="w-full figma-input"
                placeholder="XXXX XXXX XXXX XXXX"
                value={cardData?.card_number}
                error={cardError?.card_number}
                onChange={(e) => {
                  checkCartType(e.target.value);
                  setCardData({
                    ...cardData,
                    card_number: CUSTOM.strFormat(e.target.value, "number|max:16"),
                  });
                  setCardError({ ...cardError, card_number: "" });
                }}
                endAdornment={
                  cardTypeError?.image ? (
                    <img src={cardTypeError?.image} className="h-5 rtl:ml-3 card-type-img-in-card-no" alt="Card Type" />
                  ) : null
                }
              />
            </div>

            {/* Expiry + CVV side by side */}
            <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-4 w-full mb-3">
              <div className="flex flex-col">
                <Text className="text-[14px] font-medium leading-[16px] font-['Inter'] text-[#6D737E] mb-1.5">
                  {t("expirationDate")} *
                </Text>
                <Input
                  className="w-full figma-input"
                  placeholder="MM/YY"
                  value={cardData?.expiration_date}
                  error={cardError?.date}
                  onChange={(e) => {
                    setCardData({
                      ...cardData,
                      expiration_date: CUSTOM.strFormat(e.target.value, "max:15|expiry_date"),
                    });
                    setCardError({ ...cardError, date: "" });
                  }}
                />
              </div>
              <div className="flex flex-col">
                <Text className="text-[13px] text-gray-600 font-['Inter'] mb-1.5">
                  {t("cvv") || "CVV"} *
                </Text>
                <Input
                  className="w-full"
                  placeholder="•••"
                  type="password"
                  value={cardData?.cvv}
                  error={cardError?.cvv}
                  onChange={(e) => {
                    setCardData({
                      ...cardData,
                      cvv: CUSTOM.strFormat(e.target.value, "max:4|number"),
                    });
                    setCardError({ ...cardError, cvv: "" });
                  }}
                />
              </div>
            </div>

            {/* Save card checkbox */}
            <div className="flex items-center justify-start w-full mb-5">
              <CheckboxCustom
                checked={cardData?.remember_me == "YES"}
                onChange={(e) => {
                  setCardData({
                    ...cardData,
                    remember_me: e.target.checked ? "YES" : "NO",
                  });
                }}
              />
              <Text className="text-[13px] text-black-900 font-['Inter'] ml-2 rtl:ml-0 rtl:mr-2">
                {t("saveCardDetailsForFuturePurpose") || "Save card for faster future payments."}
              </Text>
            </div>
          </>
        )}

        {/* ── Apple Pay (hidden when showing card form, shown in saved view) ── */}
        {!!showApplePayButton && !showAddCard && (
          <div
            className="flex flex-row gap-3 items-center justify-start w-full py-3 border-t border-gray-100 mb-5 cursor-pointer"
            onClick={() => handleTabClick(2)}
          >
            <Radio
              className="flex"
              name="paymentMode"
              checked={activeTab === 2}
              onChange={() => handleTabClick(2)}
            />
            <Text className="text-[14px] text-black-900 font-['Inter']">
              {"Pay with Apple Pay"}
            </Text>
            {activeTab === 2 && (
              <div className="hidden111 max-w-[580px] w-full flex flex-col items-start justify-start mt-6 mb-[18px]">
                {!auth?.email ? (
                  <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full mb-2">
                    <TextField
                      required
                      label={t("Email")}
                      type="text"
                      value={applePayEmail}
                      error={!!applePayError}
                      helperText={applePayError || " "}
                      onChange={(e) => {
                        let email = CUSTOM.strFormat(e.target.value, "max:50|email");
                        setApplePayEmail(email);
                        checkApplePayEmail(email);
                      }}
                    />
                  </div>
                ) : null}
                <div className="grid grid-cols-2 xs:grid-cols-1 gap-x-5 w-full mb-2">
                  <ApplePayComponent
                    applePayData={{ amount: CUSTOM.setPrice(paymentData?.amount) }}
                    payViaOtherSource={paymentProcess}
                    isApplePayEnabled={auth?.email || (applePayEmail && !applePayError)}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── Pay Now button ── */}
        <button
          className="w-full py-[14px] rounded-full text-white text-[15px] font-semibold font-['Inter'] tracking-wide cursor-pointer transition-opacity hover:opacity-90 disabled:opacity-50"
          style={{ backgroundColor: "#7B1A3C" }}
          disabled={!paymentData?.amount || paymentData?.amount == 0}
          onClick={() => verifyCart()}
        >
          <Text className="text-[16px] font-medium leading-[24px] text-center font-['Unbounded'] text-[#FFFFFF]">
            {t("payNow")}
          </Text>
        </button>

        {/* ── Secure payment footer ── */}
        <div className="flex flex-row items-center justify-center gap-2 mt-4">
          <Img
            className="h-4 w-4"
            src="/images/img_shielddone.svg"
            alt="secure"
          />
          <Text className="text-[12px] text-gray-400 font-['Inter']">
            {t("100SecurePaymentsPoweredByRabbitHole")}
          </Text>
        </div>

        {/*
          ── COMMENTED: old absolute positioned secure payment box ──
          <div className="bg-red-50_01 flex xs:flex-col gap-4 flex-row items-center justify-between
                          py-[22px] px-[30px] xs:p-5
                          absolute bottom-[-88px] xs:bottom-[-148px] left-[-24px] xs:-left-4 payment-secure-box">
            ...
          </div>
        */}

        {/*
          ── COMMENTED: old step == 2 wrapper that hid entire payment section ──
          {paymentData?.step == 2 ? (
            ... all payment content ...
          ) : null}
        */}
      </div>

      {MoneyAddedOpen === true ? (
        <MoneyAdded closepopup={setMoneyAddedOpen} />
      ) : null}
    </>
  );
};

export default Payment;